// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.impersonation-selectr {
  width: 350px;
  color: var(--text-color);
}`, "",{"version":3,"sources":["webpack://./js/components/nav-bar/impersonationPanel.vue","webpack://./impersonationPanel.vue"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,wBAAA;ACAF","sourcesContent":["\n.impersonation-selectr {\n  width: 350px;\n  color: var(--text-color);\n}\n",".impersonation-selectr {\n  width: 350px;\n  color: var(--text-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
